<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab v-if="Core.Session.AuthUser.can('report_system_user')">
                <template slot="title">
                    <i class="fa fa-user-secret mr-2"></i>{{Core.Definition.getDefinition('Utilisateurs')}}
                </template>
                <ReportSystemUser class="mt-4"></ReportSystemUser>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import ReportSystemUser from './User'
    export default {
        name: 'ReportSystemPanel',
        components: {
            ReportSystemUser,
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>
